import React from 'react';
import { Col, Container, Row, Button, Form } from 'react-bootstrap';

const RadeemPointsSettings = () => {
    return (
        <Container fluid>
            <h3>Rewards Points Settings</h3>
            <Row className="mx-auto w-50">
                <Col>
                    <Form.Label bsPrefix="label-radeem"> Distance Unit</Form.Label>
                    <Form.Control className="login-input shadow-none" type="text" placeholder=" Add distance unit" />

                    <Form.Label bsPrefix="label-radeem">GHG Unit</Form.Label>
                    <Form.Control className="login-input shadow-none" type="text" placeholder=" Add GHG unit" />

                    <Form.Label bsPrefix="label-radeem"> GHG Emission Saved</Form.Label>
                    <Form.Control className="login-input shadow-none" type="text" placeholder=" GHG Emission saved per distance unit traveled" />

                    <Form.Label bsPrefix="label-radeem"> GHG Points Awarded</Form.Label>
                    <Form.Control className="login-input shadow-none" type="text" placeholder=" Points awarded for per GHG unit saved" />
                </Col>
                <Row className="p-0 mt-3">
                    <Col className="d-flex justify-content-end p-0">
                        <Button bsPrefix="submit-btn" size="md">
                            Submit
                        </Button>
                    </Col>
                </Row>
            </Row>
        </Container>
    );
};

export default RadeemPointsSettings;
